import { GENERAL_IDENTIFIERS } from '../../types/Identifiers';
import { validateTagStructure } from '../utils/validate-tag-structure';
import { TAG_SCHEMAS } from '../../types/TagSchemas';
import { TAG_TYPES } from '../../types/TagTypes';
import { filterIdentifierKeys } from '../filters/filter-identifier-keys';
export var identifyCustomTag = function (tag, ignoreList) {
    if (ignoreList === void 0) { ignoreList = []; }
    var identifierKeys = filterIdentifierKeys(GENERAL_IDENTIFIERS, ignoreList);
    return identifierKeys.find(function (identifier) {
        var schema = TAG_SCHEMAS[identifier];
        if (!schema || !tag.props) {
            return false;
        }
        switch (tag.type) {
            case TAG_TYPES.LINK:
                schema = schema(tag.props.rel);
                break;
            case TAG_TYPES.META:
                schema =
                    identifier === GENERAL_IDENTIFIERS.SATANDARD_META
                        ? schema(tag.props.name)
                        : schema(tag.props.property);
                break;
            default:
                return false;
        }
        return validateTagStructure(tag, schema);
    });
};
